// extracted by mini-css-extract-plugin
export default {"helperHeader":"investors-helper_helperHeader__DNbrn","helperFooter":"investors-helper_helperFooter__87y6F"};